/* istanbul ignore file */
export enum StepNames {
  SelectDistribution = "Select distribution",
  SelectPositions = "Select positions",
  PaymentDetails = "Payment details",
  ReviewAndSubmit = "Review and submit",
  Complete = "Complete",
  Error = "Error",
}
